import { get } from 'lodash';
import React, { FC, ReactNode } from 'react';
import { RemoteCompleteUserSelector, RemoteCompleteUserSelectorProps } from './remote-auto-complete';
import { PropsWithStyle, RawUserValues } from './types';

export type InputRawUser = {
  chnName: string;
  id: string;
};

export interface WOAUserInputSelectorProps extends Omit<RemoteCompleteUserSelectorProps<RawUserValues>, 'onChange' | 'fetcher'> {
  onChange?: (values: RawUserValues) => void;
  onFinish?: (values: RawUserValues) => void;
  limit?: number;
  labelRender?: (user: InputRawUser) => ReactNode;
}

export const WOAUserInputSelector: FC<PropsWithStyle<WOAUserInputSelectorProps>> = (props) => {
  const { onChange, onFinish, labelRender, ...resetProps } = props;
  const [values, setValues] = React.useState<RawUserValues>(props.defaultValue || []);

  const fetchOaUser = async (search: string) => {
    const res = await fetch(`https://api-public.wuji.woa.com/api/dept-rtx/search-staffs?q=${search}`);
    const resJson = await res.json();
    const userList = get(resJson, 'data', []);

    return userList.map((item: any) => ({
      value: item.id,
      label: labelRender ? labelRender(item) : item.id,
    }));
  };

  return (
    <RemoteCompleteUserSelector
      fetcher={fetchOaUser}
      onChange={(values: RawUserValues) => {
        setValues(values);
        onChange?.(values);
      }}
      onBlur={() => onFinish?.(values)}
      {...resetProps}
    />
  );
};
